


console.log("JSの読み込み");
document.addEventListener("DOMContentLoaded", function() {
    let intervalID; // intervalIDを関数の外で宣言

    // 現在の日時とターゲット日時を比較する関数
    function checkDateAndToggleElements() {
        // 開始日時を取得
        const startDateElement = document.getElementById("startDate");
        const startDate = new Date(startDateElement.getAttribute("data-date"));
        console.log(startDate);

        // 現在の日時を取得
        const currentDate = new Date();
        console.log(currentDate);

        // 開始日時と現在の日時を比較
        if (currentDate > startDate) {
            const productFormWrap = document.getElementById("productFormWrap");
            const startContent = document.getElementById("startContent");
            console.log(productFormWrap);
            console.log(startContent);
            
            // 開始日時が過ぎていればフォームを表示
            if (productFormWrap) {
                productFormWrap.style.display = "block";
                console.log("ボタン表示");
            }
            
            // 開始日時が過ぎていれば開始用のコンテンツを非表示
            if (startContent) {
                startContent.style.display = "none";
                console.log("コンテンツ非表示");
                
                // startContentが非表示になったので、intervalIDを使って定期実行を停止
                if (intervalID) {
                    clearInterval(intervalID);
                }
            }
        } else {
            // 開始日時がまだの場合はフォームを非表示にし、開始用のコンテンツを表示
            if (productFormWrap) {
                productFormWrap.style.display = "none";
                console.log("ボタン非表示");
            }
            if (startContent) {
                startContent.style.display = "block";
                console.log("コンテンツ表示");
            }
        }
    }

    // 初回の関数実行
    checkDateAndToggleElements();

    // 5秒ごとに関数を定期的に実行
    intervalID = setInterval(checkDateAndToggleElements, 5000);
});
console.log("JSの終了");
